import * as React from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Zoom from 'yet-another-react-lightbox/plugins/zoom'
import Caption from 'yet-another-react-lightbox/plugins/captions'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/counter.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import './listing_page_photos.css'

const ListingPagePhotos = ({ images, viewAllImagesText, title }) => {
  const [open, setOpen] = React.useState(false)
  const [index, setIndex] = React.useState(0)

  const getDescription = (image, imageIndex) => {
    const { caption } = image
    const indexPart = `(${imageIndex + 1}/${images.length})`

    return `${caption ? `${caption} ` : ''}${indexPart}`
  }

  if (!images || images.length === 0) {
    return
  }

  return (
    <>
      <div className="my-6 w-full border-t border-gray-400" />
      <h2 className="font-bold text-3xl leading-[40px]">{title}</h2>
      <div id="photos-container" className="flex flex-wrap gap-4 mt-4">
        {images.slice(0, 6).map((image, currentIndex) => {
          return (
            <div
              className="listing-pages-photos-grid-photo-size"
              key={image.src}
              onClick={() => {
                setIndex(currentIndex)
                setOpen(true)
              }}
            >
              <img
                id={`listing-pages-photos-grid-photo-${image.src}`}
                src={`${image.src}-/format/auto/-/quality/lightest/-/scale_crop/500x500/center/`}
                height="250"
                width="250"
              />
            </div>
          )
        })}
      </div>

      <button
        className="mt-4"
        onClick={() => {
          setIndex(0)
          setOpen(true)
        }}
      >
        <span className="text-wonder-blue-link font-bold leading-[24px] cursor-pointer">
          {viewAllImagesText}
        </span>
      </button>

      <Lightbox
        index={index}
        open={open}
        close={() => setOpen(false)}
        plugins={[Caption, Zoom]}
        counter={{
          container: {
            style: { padding: '10px 20px' },
            class:
              'unset bottom-0 w-full flex absolute text-white justify-center bg-black bg-opacity-50 padding: 10px 20px; leading-[1.15] max-h-[150px] text-base',
          },
        }}
        animation={{ zoom: 0 }}
        styles={{
          toolbar: {
            background: 'rgba(0, 0, 0, 0.5)',
            width: '100%',
            height: '50px',
            padding: '0 20px 0 20px',
          },
          container: {
            background: 'rgba(0, 0, 0, 0.85)',
            padding: '0',
          },
        }}
        carousel={{
          padding: '8px',
        }}
        zoom={{
          maxZoomPixelRatio: 10,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
          doubleClickDelay: 300,
          doubleClickMaxStops: 2,
          keyboardMoveDistance: 50,
          wheelZoomDistanceFactor: 100,
          pinchZoomDistanceFactor: 100,
          scrollToZoom: true,
        }}
        slides={images.map((image, currentIndex) => {
          return {
            src: `${image.src}-/preview/2000x2000/-/format/auto/`,
            description: getDescription(image, currentIndex),
          }
        })}
        captions={{
          descriptionTextAlign: 'center',
        }}
        controller={{ closeOnBackdropClick: true }}
      />
    </>
  )
}

export default ListingPagePhotos
